import { GET_BRAND_PAGE_CONTENT, BRAND_PAGE_CONTENT_API_SUCCESS, BRAND_PAGE_CONTENT_API_ERROR } from '../../constants';
export function getBrandPageContentCall(payload) {
    return {
        type: GET_BRAND_PAGE_CONTENT,
        payload,
    };
}
export function brandPageContentSuccess(result) {
    return {
        type: BRAND_PAGE_CONTENT_API_SUCCESS,
        response: result,
    };
}
export function brandPageContentError() {
    return {
        type: BRAND_PAGE_CONTENT_API_ERROR,
    };
}
